var map = {
	"./cs/core": [
		5016,
		16
	],
	"./da/core": [
		5959,
		959
	],
	"./de/core": [
		4371,
		371
	],
	"./en/core": [
		4987
	],
	"./es/core": [
		462,
		462
	],
	"./fr/core": [
		3238,
		238
	],
	"./it/core": [
		1513,
		513
	],
	"./ja/core": [
		9245,
		245
	],
	"./ko/core": [
		5652,
		652
	],
	"./pl/core": [
		6174,
		174
	],
	"./pt-BR/core": [
		3705,
		705
	],
	"./ru/core": [
		8745,
		745
	],
	"./sk/core": [
		8608,
		608
	],
	"./sv/core": [
		5869,
		869
	],
	"./uz/core": [
		2719,
		719
	],
	"./zh/core": [
		1804,
		804
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;